import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import Link from "next/link";
import { getCategoryUrl } from "@/lib/contentful/categoryUrl";
import { getEntry } from "@/lib/contentful/guards";
import type { TypeAuthorSkeleton, TypeBlogCategorySkeleton } from "@/types/contentful/generated";
type ResolvedCategory = Entry<TypeBlogCategorySkeleton, undefined, string>;
function dedupeCategories(categories: ResolvedCategory[]) {
  const seen = new Set<string>();
  const result: {
    id: string;
    name: string;
    url: string;
  }[] = [];
  for (const cat of categories) {
    if (!seen.has(cat.sys.id)) {
      seen.add(cat.sys.id);
      result.push({
        id: cat.sys.id,
        name: cat.fields.name,
        url: getCategoryUrl(cat)
      });
    }
    const parentCat = getEntry(cat.fields.parentCategory);
    if (parentCat && !seen.has(parentCat.sys.id)) {
      seen.add(parentCat.sys.id);
      result.push({
        id: parentCat.sys.id,
        name: parentCat.fields.name,
        url: getCategoryUrl(parentCat)
      });
    }
  }
  return result;
}
interface Props {
  author: Entry<TypeAuthorSkeleton, undefined, string> | null;
  categories: (ResolvedCategory | UnresolvedLink<"Entry">)[] | undefined;
  draftMode?: boolean;
}
export const BlogArticleFooter = t0 => {
  const $ = _c(15);
  const {
    author,
    categories,
    draftMode
  } = t0;
  let t1;
  if ($[0] !== author) {
    t1 = getEntry(author);
    $[0] = author;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const resolvedAuthor = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] !== categories || $[3] !== draftMode || $[4] !== resolvedAuthor) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const resolvedCategories = categories?.filter(_temp) ?? [];
      if (!resolvedAuthor && resolvedCategories.length === 0) {
        t5 = null;
        break bb0;
      }
      const dedupedCategories = dedupeCategories(resolvedCategories);
      t2 = "text-sm font-normal leading-none p-6 max-w-3xl mx-auto w-full";
      if ($[9] !== resolvedAuthor) {
        t3 = resolvedAuthor && <>by <span className="font-semibold">{resolvedAuthor.fields.name}</span></>;
        $[9] = resolvedAuthor;
        $[10] = t3;
      } else {
        t3 = $[10];
      }
      t4 = dedupedCategories.length > 0 && <>{" posted in "}<span className="font-semibold">{dedupedCategories.map((cat, i) => <span key={cat.id}>{draftMode ? cat.name : <Link href={cat.url}>{cat.name}</Link>}{i < dedupedCategories.length - 1 && ", "}</span>)}</span></>;
    }
    $[2] = categories;
    $[3] = draftMode;
    $[4] = resolvedAuthor;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t6 = <footer className={t2}>{t3}{t4}</footer>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp(c) {
  return "fields" in c;
}